export {
  default as PositionAnimated,
  type PositionAnimatedProps,
} from './PositionAnimated';
